import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import React, { useEffect, useMemo, useState } from "react";
import RffBooleanToggleField from "../components/finalForm/inputs/RffBooleanToggleField";
import RffEmailField from "../components/finalForm/inputs/RffEmailField";
import RffPhoneField from "../components/finalForm/inputs/RffPhoneField";
import RffSelectField from "../components/finalForm/inputs/RffSelectField";
import RffTextareaField from "../components/finalForm/inputs/RffTextareaField";
import RffTextField from "../components/finalForm/inputs/RffTextField";
import RffFullPageFormStepper from "../components/finalForm/RffFullPageFormStepper";

import Add from "@mui/icons-material/Add";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import ExpandMoreRounded from "@mui/icons-material/ExpandMoreRounded";
import { grey } from "@mui/material/colors";
import isEmpty from "lodash/isEmpty";
import isNil from "lodash/isNil";
import { useFormState } from "react-final-form";
import { FieldArray } from "react-final-form-arrays";
import RffLoanBorrowerExperienceTable from "../components/finalForm/features/RffLoanBorrowerExperienceTable";

import RffBooleanCheckbox from "../components/finalForm/inputs/RffBooleanCheckbox";
import RffDateField from "../components/finalForm/inputs/RffDateField";
import RffDollarField from "../components/finalForm/inputs/RffDollarField";
import RffFileUploadField from "../components/finalForm/inputs/RffFileUploadField";
import RffNumberField from "../components/finalForm/inputs/RffNumberField";
import RffPercentField from "../components/finalForm/inputs/RffPercentField";
import RffSelectMultipleField from "../components/finalForm/inputs/RffSelectMultipleField";
import RffSelectToggleField from "../components/finalForm/inputs/RffSelectToggleField";
import RffSignatureField from "../components/finalForm/inputs/RffSignatureField";
import RffSsnField from "../components/finalForm/inputs/RffSsnField";
import RffConditional from "../components/finalForm/shared/RffConditional";
import RffGroup from "../components/finalForm/shared/RffGroup";

import Flx from "../components/layout/Flx";
import Htag from "../components/typography/Htag";
import Txt from "../components/typography/Txt";
import { selectOptionsEntityType } from "../constants/selectOptions/selectOptionsEntityType";
import { selectOptionsHousingEvents } from "../constants/selectOptions/selectOptionsHousingEvents";
import { selectOptionsLoanProductType } from "../constants/selectOptions/selectOptionsLoanProductType";
import { selectOptionsLoanPurpose } from "../constants/selectOptions/selectOptionsLoanPurpose";
import { selectOptionsMaritalStatus } from "../constants/selectOptions/selectOptionsMaritalStatus";
import { selectOptionsPropertyConditionAtOrigination } from "../constants/selectOptions/selectOptionsPropertyConditionAtOrigination";
import { selectOptionsPropertyType } from "../constants/selectOptions/selectOptionsPropertyType";
import { selectOptionsUsaStates } from "../constants/selectOptions/selectOptionsUsaStates";
import { useBorrowerSubmissionsHook } from "../hooks/useBorrowerSubmissionsHook";
import RffSelectAutocompleteField from "../components/finalForm/inputs/RffSelectAutocompleteField";
import RffAddressEditingField from "../components/finalForm/inputs/RffAddressEditingField";

const dependentGroupStyles = {
  ml: 1,
  borderLeft: `2px solid var(--titleColor)`,
  pl: 3,
  pt: 2,
  pb: 1,
  mt: -2,
  mb: "8px !important",
  background:
    "linear-gradient(90deg, rgba(43,34,102,0.04) 0%, rgba(255,255,255,1) 100%)",
};

const LoanApplicationFormScreen = ({ initialValues }) => {
  const [success, setSuccess] = useState(false);
  const { loading, createApplication } = useBorrowerSubmissionsHook();

  const [hideLogo, setHideLogo] = useState(false);
  const [customLogoName, setCustomLogoName] = useState(null);

  useEffect(() => {
    try {
      const params = new URLSearchParams(window.location.search);

      const hideLogoParam = params.get("hideLogo");
      const brandingNameParam = params.get("brandingName");

      setHideLogo(hideLogoParam === "true");
      setCustomLogoName(brandingNameParam || null);
    } catch (e) {
      setHideLogo(false);
      setCustomLogoName(null);
    }
  }, []);

  const onFormSubmit = (data) => {
    createApplication({
      payload: data,
      onSuccessFn: (d) => {
        console.log("Success", d);
        setSuccess(true);
      },
    });
  };

  const init = useMemo(() => {
    if (isNil(initialValues)) {
      return { subjectProperties: [{}] };
    }
    return initialValues;
  }, [initialValues]);

  return (
    <RffFullPageFormStepper
      className={"required"}
      loading={loading}
      hideLogo={hideLogo && isNil(customLogoName)}
      success={success}
      initialValues={init}
      customLogoName={customLogoName}
      onSubmit={onFormSubmit}
      formTitle={"Loan Application"} // 👈 optional usage
      formDescription="Please provide the required information below. Let's start by learning a little more about you."
      finalStepLabel="Submit"
      sx={{
        ".input-wrapper-root.required": {
          border: "1px solid red",
        },
      }}
    >
      <BorrowerDetailsPage stepName="Borrower Details" />
      <BackgroundPage stepName="Background & Experience" />
      <LoanDetailPage stepName="Loan Details" />
      <SubjectPropertiesPage stepName="Properties" />
      <BorrowingEntitiesPage stepName="Borrowing Entities" />
      <ConfirmationPage stepName="Confirmation" />
    </RffFullPageFormStepper>
  );
};
// const LoanApplicationFormScreen = ({ initialValues, hideLogo = false }) => {
//   const [success, setSuccess] = useState(false);
//   const { loading, createApplication } = useBorrowerSubmissionsHook();
//   // const { loading, createLoanApplication } = useUnauthenticatedHook();

//   const onFormSubmit = (data) => {
//     // console.log("Submit", data);
//     createApplication({
//       payload: data,
//       // errorTesting: true,
//       onSuccessFn: (d) => {
//         console.log("Success", d);
//         setSuccess(true);
//       },
//     });
//   };

//   const init = useMemo(() => {
//     if (isNil(initialValues)) {
//       return { subjectProperties: [{}] };
//     }
//     return initialValues;
//   }, [initialValues]);

//   return (
//     <>
//       <RffFullPageFormStepper
//         className={"required"}
//         loading={loading}
//         hideLogo={hideLogo}
//         // defaultStep={3}
//         success={success}
//         // allowStepClickThrough

//         // initialValues={ex_sub}
//         // initialValues={loanApp2}
//         initialValues={init}
//         // initialValues={{ subjectProperties: [{}] }}
//         onSubmit={onFormSubmit}
//         formTitle={"Loan Application"}
//         // formTitle={"ResiLender Loan Application"}
//         formDescription="Please provide the required information below. Let's start by learning a little more about you."
//         finalStepLabel="Submit"
//         sx={{
//           ".input-wrapper-root.required": {
//             border: "1px solid red",
//           },
//         }}
//       >
//         <BorrowerDetailsPage stepName="Borrower Details" />
//         <BackgroundPage stepName="Background & Experience" />
//         <LoanDetailPage stepName="Loan Details" />
//         <SubjectPropertiesPage stepName="Properties" />
//         <BorrowingEntitiesPage stepName="Borrowing Entities" />
//         <ConfirmationPage stepName="Confirmation" />
//       </RffFullPageFormStepper>
//     </>
//   );
// };

/**Step 1 */
const BorrowerDetailsPage = ({ testing }) => {
  return (
    <>
      <RffGroup title={"Borrower Details"}>
        <RffTextField name="firstName" label="First Name" size={6} />
        <RffTextField name="lastName" label="Last Name" size={6} />
        <RffPhoneField name="phone" label="Phone" />
        <RffEmailField name="emailAddress" label="Email" />
        <RffSelectToggleField
          name="citizenshipStatus"
          label="Please select your citizenship category"
          options={[
            "US Citizen",
            "Foreign National with SSN",
            "Foreign National",
            "Foreign National Non-Resident",
            "Other - Options do not apply",
          ]}
        />

        <RffConditional
          operatorForMultiple={"OR"}
          rules={[
            { field: "citizenshipStatus", operator: "==", value: "US Citizen" },
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Foreign National with SSN",
            },
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Foreign National",
            },
          ]}
        >
          <RffAddressEditingField
            name="primaryAddress"
            label="Primary Address"

            // required={testing?.required}
          />
        </RffConditional>
        <RffConditional
          operatorForMultiple={"OR"}
          rules={[
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Foreign National Non-Resident",
            },
            {
              field: "citizenshipStatus",
              operator: "==",
              value: "Other - Options do not apply",
            },
          ]}
        >
          <RffTextField
            name="nonUSborrowerAddress"
            label="Enter non-US address"
          />
        </RffConditional>

        <RffDateField name="dateOfBirth" label="Enter date of birth" />
        <RffBooleanToggleField
          name="borrowerHasSSN"
          label="Do you have a US issued Social Security Number?"
        />
        <RffConditional field={"borrowerHasSSN"} value={true}>
          <RffSsnField name="borrowerSSN" label="Social Security Number" />
        </RffConditional>
        <RffSelectToggleField
          name="maritalStatus"
          label="What is your marital Status?"
          options={selectOptionsMaritalStatus}
        />
      </RffGroup>
      <RffGroup titleType="h2" title="Upload Identification">
        <RffFileUploadField
          label="Upload a clear copy of your government issued identification"
          docGroup={"Borrower Documents"}
          docType={"Photo Identification"}
          required
        />
      </RffGroup>
    </>
  );
};

/**Step 2 */
const BackgroundPage = ({ testing }) => {
  const { values } = useFormState();
  return (
    <>
      <RffGroup title="Borrower Background">
        <RffDollarField
          name="cashLiquidity"
          label="Please detail your total cash liquidity in personal and/or entity bank accounts"
        />
        <RffDollarField
          name="otherLiquidity"
          label="Please detail total value of other liquidity sources"
          helperText="Including money market/securities account, cash value of life insurance policies, IRA or 401k accounts"
        />
        <RffSelectToggleField
          name="estimatedFICO"
          label="What is your estimated FICO range?"
          options={[
            "Below 600",
            "600-620",
            "620-650",
            "650-680",
            "680-700",
            "700-720",
            "Greater than 720",
            "N/A do not have FICO",
          ]}
        />
        <RffBooleanToggleField
          name="application_felony_conviction"
          label="Have you ever been convicted of a felony?"
        />
        <RffBooleanToggleField
          name="application_financial_fraud_misdemeanor"
          label="Have you ever been convicted of any financial or fraud related crimes including misdemeanors?"
        />
        <RffBooleanToggleField
          name="bankruptcy_flag"
          label="Have you filed for bankruptcy in the last 5 years?"
        />
        <RffBooleanToggleField
          name="firstTimeHomebuyer"
          label="Are you a first-time home buyer?"
        />
      </RffGroup>

      <RffGroup title="Do you have any of the following open:">
        <RffBooleanToggleField
          name="open_liens_judgments"
          label="Charge offs, federal or state tax liens, pending litigation or financial judgments"
        />
        <RffConditional field="open_liens_judgments" value={true}>
          <RffGroup
            titleType="h3"
            disableGrid
            isGridChild
            title="Select All That Apply"
            sx={dependentGroupStyles}
          >
            <RffBooleanCheckbox
              suppressGrid
              name="charge_offs"
              label="Charge Offs"
            />
            <RffBooleanCheckbox
              suppressGrid
              name="tax_liens"
              label="Tax Liens"
            />
            <RffBooleanCheckbox
              suppressGrid
              name="financial_judgements"
              label="Financial Judgements"
              options={[
                "Charge Offs",
                "Tax Liens",
                "Financial Judgements",
                "Pending Litigation",
              ]}
            />
            <RffBooleanCheckbox
              suppressGrid
              name="pending_litigation"
              label="Pending Litigation"
            />
          </RffGroup>
        </RffConditional>
      </RffGroup>

      <RffGroup title="Do any of the following apply in the last three years:">
        <RffSelectMultipleField
          name="housing_events"
          label="Entered into a loan forbearance or modification program, a property  owned as individual or through an entity under your control subject to lis pendens or foreclosure or any mortgage lates?"
          options={selectOptionsHousingEvents}
          helperText="Select all that apply"
        />
        {isEmpty(values?.housing_events) ? null : (
          <RffSelectToggleField
            name="time_since_housing_event"
            label="Time Since Last Housing Event"
            options={[
              "Within the last 12-months",
              "Within the last 2-years",
              "Greater than 2-years ago",
            ]}
          />
        )}
      </RffGroup>

      <RffGroup title="Experience">
        <RffTextareaField
          name="borrowerExperienceSummary"
          label="Summary of borrower property investor experience"
        />
        <RffBooleanToggleField
          name="hasExperienceWithIncomeProducingProperties"
          label="Do you have experience With Income Producing Properties?"
        />

        <RffBooleanToggleField
          name="hasExperienceWithFixFlips"
          label="Do you have experience With Fix Flips?"
        />

        <RffBooleanToggleField
          name="hasExperienceWithGroundUpConstruction"
          label="Do you have experience With Ground Up Construction?"
        />

        <RffLoanBorrowerExperienceTable />
      </RffGroup>
    </>
  );
};

/**Step 3 */
const LoanDetailPage = ({ testing }) => {
  return (
    <>
      <RffGroup titleType="h2" title="Loan Details">
        <RffSelectToggleField
          name="loanProductType"
          label="Loan Product Type"
          options={selectOptionsLoanProductType}
        />
        <RffSelectToggleField
          name="loanPurpose"
          label="Loan Purpose"
          options={selectOptionsLoanPurpose}
        />
        <RffTextareaField
          name="exitStrategy"
          label="Exit Strategy"
          minHeight={80}
          placeholder="Explain how you plan to repay or exit this loan"
        />

        <RffDateField
          name="expectedClosingDate"
          label="What is the expected closing date for the loan?"
        />
        <RffBooleanToggleField
          name="brokerDeal"
          label="Working with a third-party broker?"
        />
        <RffConditional
          operatorForMultiple={"OR"}
          rules={[
            {
              field: "loanProductType",
              operator: "==",
              value: "Stabilized Bridge",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "30-Year Rental Loan",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Other",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Foreclosure Bail Out",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "DSCR",
            },
          ]}
        >
          <RffDollarField name="baseLoanAmount" label="Requested Loan Amount" />
        </RffConditional>

        <RffConditional
          operatorForMultiple={"OR"}
          rules={[
            {
              field: "loanProductType",
              operator: "==",
              value: "Fix and Flip",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Ground Up Construction",
            },
            {
              field: "loanProductType",
              operator: "==",
              value: "Vacant Land",
            },
          ]}
        >
          <RffDollarField
            size={4}
            name="baseLoanAmount"
            label="Initial loan amount"
            helperText="Amount before any draws"
          />
          <RffDollarField
            size={4}
            name="totalHoldback"
            label="Total financed budget"
            helperText="Total amount requested via draws"
          />
          {/* Render this only when totalHoldback < totalConstructionBudget */}
          <RffDollarField
            size={4}
            name="totalConstructionBudget"
            label="Total construction budget"
            helperText="The full project cost (if draws cover less than 100% of it)"
          />
        </RffConditional>
      </RffGroup>
      <RffConditional
        field="loanPurpose"
        operator="includes"
        value={[
          "Refinance - No Cash Out",
          "Refinance - Cash Out",
          "Delayed Purchase",
        ]}
      >
        <RffGroup titleType="h2" title="Refinanced Details">
          <RffConditional
            field="loanPurpose"
            operator="includes"
            value={[
              "Refinance - No Cash Out",
              "Refinance - Cash Out",
              "Delayed Purchase",
            ]}
          >
            <RffDollarField
              name="outstandingLoanUpb"
              label="Total principal amount of outstanding loan (this would be your expected payoff) :"
            />

            <RffTextField
              name="exisitingLender"
              label="What is the name of the current lender?"
            />
            <RffDateField
              name="existingLoanMaturityDate"
              label="Maturity date of existing loan :"
            />
            <RffBooleanToggleField
              name="existingLoanLatePayments"
              label="Have there ever been any payments made more than 30-days from due date on the existing loan?"
            />
            <RffBooleanToggleField
              name="existingLoanInDefault"
              label="Is the current loan in default (either payment or maturity default)?"
            />
            <RffConditional field="existingLoanInDefault" value={true}>
              <RffSelectField
                name="existingLoanDefaultType"
                label="Select existing loan default type:"
                options={["Maturity Default", "Payment Default"]}
              />
            </RffConditional>
            <RffBooleanToggleField
              name="existingLoanHasUndrawnBudget"
              label="Existing Loan Has Undrawn Budget"
            />
            <RffConditional
              field="existingLoanUndrawnBudgetAmount"
              value={true}
            >
              <RffDollarField
                name="existingLoanUndrawnBudgetAmount"
                label="Existing Loan Undrawn Budget Amount"
              />
            </RffConditional>
            <RffBooleanToggleField
              name="propertyListedForSale"
              label="Is the property currently listed for sale?"
            />
          </RffConditional>
          <RffConditional
            field="loanPurpose"
            operator="includes"
            value={["Refinance - No Cash Out", "Refinance - Cash Out"]}
          >
            <RffBooleanToggleField
              name="propertyListedForSaleLastSixMonths"
              label="Has the property been listed for sale in the last six months?"
            />
          </RffConditional>
        </RffGroup>
      </RffConditional>
    </>
  );
};

/**Step 4 */
const SubjectPropertiesPage = ({ testing }) => {
  return (
    <>
      <RffGroup disableGrid titleType="h2" title="Properties">
        <RffSelectToggleField
          name={"subjectPropertyCount"}
          label="Select the number of properties to be financed for this loan application"
          options={["1", "2", "3", "4+ properties"]}
        />
      </RffGroup>
      <RffGroup disableGrid titleType="h2" title="Property Information">
        <FieldArray name={"subjectProperties"}>
          {({ fields: arrayFields, meta }) => {
            return (
              <React.Fragment>
                {arrayFields.map((fieldName, index) => (
                  <React.Fragment key={fieldName}>
                    <Accordion
                      defaultExpanded
                      sx={{
                        m: "0 !important",
                        borderRadius: "4px",
                        boxShadow: "0 0 0px 1px #dde0e4",
                        overflow: "hidden",
                      }}
                    >
                      <AccordionSummary
                        sx={{ borderBottom: "1px solid #dde0e4" }}
                        expandIcon={
                          <ExpandMoreRounded sx={{ color: "#232a31" }} />
                        }
                      >
                        <Flx fw jb ac sx={{ color: "#232a31" }}>
                          <Htag h3 sx={{ color: "inherit" }}>
                            {`Property #${index + 1}`}
                          </Htag>
                          <IconButton
                            sx={{ color: "inherit" }}
                            onClick={() => arrayFields.remove(index)}
                            size="small"
                          >
                            <DeleteOutline fontSize="small" />
                          </IconButton>
                        </Flx>
                      </AccordionSummary>
                      <AccordionDetails sx={{ background: "#ffffff", p: 2.8 }}>
                        <RffGroup>
                          <RffAddressEditingField
                            name={`${fieldName}.address`}
                            label="Enter the subject property address"
                            required
                          />
                          <RffSelectToggleField
                            name={`${fieldName}.propertyType`}
                            label="Property Type"
                            options={selectOptionsPropertyType}
                          />
                          <RffConditional
                            field="loanProductType"
                            operator="includes"
                            value={["Ground Up Construction", "Vacant Land"]}
                          >
                            <RffSelectField
                              name={`${fieldName}.proposedPropertyType`}
                              label="Proposed Property Type"
                              options={selectOptionsPropertyType}
                            />
                          </RffConditional>
                          <RffDollarField
                            name={`${fieldName}.asIsValue`}
                            label="The current estimated as-is or market value of the property"
                          />
                          <RffConditional
                            field="loanProductType"
                            operator="includes"
                            value={[
                              "Fix and Flip",
                              "Ground Up Construction",
                              "Vacant Land",
                            ]}
                          >
                            <RffDollarField
                              name={`${fieldName}.arv`}
                              label="After Renovation Value"
                            />
                          </RffConditional>

                          <RffConditional
                            field="loanPurpose"
                            value={"Purchase"}
                          >
                            <RffDollarField
                              name={`${fieldName}.purchasePrice`}
                              label="What is the property purchase price?"
                            />
                            <RffDateField
                              name={`${fieldName}.purchaseDate`}
                              label="What is the expected purchase date for the property?"
                            />
                          </RffConditional>

                          <RffConditional
                            field="loanPurpose"
                            operator={"includes"}
                            value={[
                              "Refinance - No Cash Out",
                              "Refinance - Cash Out",
                              "Delayed Purchase",
                            ]}
                          >
                            <RffDollarField
                              name={`${fieldName}.originalPurchasePrice`}
                              label="What was original purchase price for the property?"
                            />
                            <RffDateField
                              name={`${fieldName}.originalPurchaseDate`}
                              label="What was original purchase date of the property?"
                            />
                          </RffConditional>
                          <RffConditional
                            field="loanPurpose"
                            value={"Purchase"}
                          >
                            <RffDollarField
                              name={`${fieldName}.assignmentFees`}
                              label="Dollar value of any assignment fees included in purchase contract"
                            />
                            <RffDollarField
                              name={`${fieldName}.sellersConcession`}
                              label="Dollar value of any seller's concession included in purchase contract"
                            />
                          </RffConditional>
                          <RffConditional
                            field="loanProductType"
                            operator={"includes"}
                            operatorForMultiple="AND"
                            rules={[
                              {
                                field: "loanProductType",
                                operator: "includes",
                                value: [
                                  "Fix and Flip",
                                  "Ground Up Construction",
                                  "Vacant Land",
                                ],
                              },
                              {
                                field: "loanPurpose",
                                operator: "includes",
                                value: [
                                  "Refinance - No Cash Out",
                                  "Refinance - Cash Out",
                                  "Delayed Purchase",
                                ],
                              },
                            ]}
                          >
                            <RffDollarField
                              name={`${fieldName}.additionalBasis`}
                              label="Any additional costs expended since purchase including costs for permits & plans, land development, renovations. Do not include taxes, insurance, interest expense or other carrying costs"
                            />
                          </RffConditional>
                          <RffConditional
                            field="loanPurpose"
                            operator={"includes"}
                            value={[
                              "Refinance - No Cash Out",
                              "Refinance - Cash Out",
                              "Delayed Purchase",
                            ]}
                          >
                            <RffBooleanToggleField
                              name={`${fieldName}.propertyListedForSale`}
                              label="Property Listed For Sale"
                            />
                            <RffDateField
                              name={`${fieldName}.lastListedForSaleDate`}
                              label="Last Listed For Sale Date"
                            />
                            <RffDollarField
                              name={`${fieldName}.lastListedForSalePrice`}
                              label="Last Listed For Sale Price"
                            />
                          </RffConditional>
                          <RffBooleanToggleField
                            name={`${fieldName}.floodZone`}
                            label="Is the property in a flood zone?"
                          />
                          <RffNumberField
                            name={`${fieldName}.residentialSqFootage`}
                            label="What is the residential square footage of the property?"
                          />
                          {/* TO FIX - Make nested conditionals work */}
                          <RffConditional
                            field={`${fieldName}.propertyType`}
                            operator={"includes"}
                            value={["Mixed-Use", "Commercial", "Other"]}
                          >
                            <RffNumberField
                              name={`${fieldName}.commercialSqFootage`}
                              label="What is the commercial square footage of the property?"
                            />
                          </RffConditional>
                          <RffConditional
                            field="loanProductType"
                            operator="includes"
                            value={[
                              "Fix and Flip",
                              "Ground Up Construction",
                              "Vacant Land",
                            ]}
                          >
                            <RffNumberField
                              name={`${fieldName}.afterRenoSqFootage`}
                              label="If renovating, the square footage after the project is completed"
                            />
                          </RffConditional>

                          <RffDollarField
                            name={`${fieldName}.annualTaxes`}
                            label="Annual Taxes"
                            size={6}
                          />
                          <RffDollarField
                            name={`${fieldName}.annualInsurance`}
                            label="Annual Insurance"
                            size={6}
                          />
                          <RffDollarField
                            name={`${fieldName}.annualFloodInsurance`}
                            label="Annual Flood Insurance"
                            size={6}
                          />
                          <RffDollarField
                            name={`${fieldName}.annualHoaFees`}
                            label="Annual Hoa Fees"
                            size={6}
                          />

                          <RffConditional
                            field="loanProductType"
                            operator="includes"
                            value={["Stabilized Bridge", "30-Year Rental Loan"]}
                          >
                            <RffDollarField
                              name={`${fieldName}.annualPropertyMgmtFees`}
                              label="Annual Property Mgmt Fees"
                              size={6}
                            />
                          </RffConditional>
                          {/* <div>---------------------------------------</div> */}
                          {/* Do the following need to have conditional values? */}
                          <RffDollarField
                            name={`${fieldName}.annualOtherExpense`}
                            label="Annual Other Expense"
                            size={6}
                          />
                          <RffSelectToggleField
                            name={`${fieldName}.propertyConditionAtOrigination`}
                            label="Property Condition At Origination"
                            options={
                              selectOptionsPropertyConditionAtOrigination
                            }
                          />
                          <RffSelectField
                            name={`${fieldName}.ffPropertyStatus`}
                            label="How would you describe the current property status for this fix and flip project?"
                            options={[
                              "Requires significant renovation",
                              "Average condition - requires moderate renovation",
                              "Above Average condition - requires limited renovation",
                            ]}
                          />
                          <RffSelectField
                            name={`${fieldName}.gucPropertyStatus`}
                            label="How would you describe the current project status for this ground up project?"
                            options={[
                              "Raw land without approved plans and/or utilities",
                              "Raw land with approved plans and utilities in place",
                              "Foundation in place",
                              "Significant Progress to Exterior, limited or no exterior work complete",
                              "Finishing Interior",
                            ]}
                          />
                          <RffDollarField
                            name={`${fieldName}.constructionBudget`}
                            label="Total construction budget for the project including hard and soft costs"
                          />
                          <RffPercentField
                            name={`${fieldName}.financedBudgetPercent`}
                            label="What is the requested total percent of construction budget to be financed?"
                          />
                        </RffGroup>
                      </AccordionDetails>
                    </Accordion>
                  </React.Fragment>
                ))}

                <Flx
                  center
                  fw
                  item
                  sx={{
                    color: "#232a31",
                  }}
                >
                  <Button
                    variant="text"
                    size="medium"
                    color="inherit"
                    fullWidth
                    startIcon={<Add />}
                    onClick={() => {
                      arrayFields.push({});
                    }}
                  >
                    Add Property
                  </Button>
                  {meta.touched && typeof meta.error === "string" && (
                    <div style={{ color: "red", marginTop: "4px" }}>
                      {meta.error}
                    </div>
                  )}
                </Flx>
              </React.Fragment>
            );
          }}
        </FieldArray>
      </RffGroup>
    </>
  );
};

/** Step 5 */
const BorrowingEntitiesPage = ({ testing }) => {
  return (
    <>
      <RffGroup titleType="h2" title="Borrowering Entities">
        <RffBooleanToggleField
          required
          name="applicantHasExistingEntity"
          label="Do you have an existing entity, such as an LLC that will be used for this transaction?"
        />
        <RffConditional field="applicantHasExistingEntity" value={false}>
          <RffNumberField
            name="applicantEntityPercentOwnership"
            label="What percentage ownership of borrower entity will you expect to own once established?"
          />
          <RffSelectAutocompleteField
            name="entityStateOfOrganization"
            label="What will be the US State of Organization for the entity?"
            options={selectOptionsUsaStates}
          />
          <RffSelectAutocompleteField
            name="entityType"
            label="Planned entity type?"
            options={selectOptionsEntityType}
          />
          <RffBooleanToggleField
            name="entityAssets"
            label="Will the entity be established to be a single asset entity? I.e. an entity set up to purchase real estate with ownership of a single property?"
          />
        </RffConditional>
        <RffConditional field="applicantHasExistingEntity" value={true}>
          <RffTextField name="entityName" label="Entity Name" />
          <RffPercentField
            name="applicantEntityPercentOwnership"
            label="What percentage ownership of borrower entity do you own?"
          />
          <RffSelectAutocompleteField
            name="entityStateOfOrganization"
            size={4}
            label="Entity State Of Organization"
            options={selectOptionsUsaStates}
          />
          <RffSelectAutocompleteField
            name="entityType"
            label="Entity Type"
            size={4}
            options={selectOptionsEntityType}
          />
          <RffDateField
            name="entityOrganizationDate"
            size={4}
            label="Entity Organization Date"
          />
          <RffBooleanToggleField
            name="entityAssets"
            label="Is this be a single asset entity? I.e. an entity set up to purchase real estate with ownership of a single property?"
          />
          <RffTextField name="entityEINNumber" label="EIN Number" />
        </RffConditional>
      </RffGroup>
    </>
  );
};

/**Step 6 -- to include? */
const ConfirmationPage = ({ testing }) => {
  return (
    <>
      <RffGroup titleType="h2" title="File Upload">
        <RffFileUploadField label="Additional File Uploads" />
      </RffGroup>
      <RffGroup titleType="h2" title="Disclosure & Signature">
        <Grid item xs={12}>
          <TextOverflow title={"Authorization Agreement"}>
            <Txt>
              Applicant attests that this application is for financing of a
              business purpose loan and any subject properties covered under
              this application are not owner occupied, used as a second home or
              vacation property, and any recent use of the property as a primary
              residence will require supporting evidence that all guarantors and
              their family members are no longer occupying the residence.
            </Txt>
            <Txt>
              The actual terms and conditions upon which the Lender might extend
              credit are subject to satisfactory completion of due diligence,
              internal approval, satisfactory review of documentation and such
              other or different items and conditions as may be determined by
              the Lender following the completion of its underwriting (the
              “Underwriting and Approval Process”). As a result, notwithstanding
              any agreement of the parties to the contrary, (i) Lender’s
              approval of the loan documents shall not constitute a final
              approval of the loan and (ii) the loan documents shall not be
              considered final until the Underwriting and Approval Process is
              completed (as determined in Lender’s sole discretion).
            </Txt>
            <Txt>
              The borrower hereby agrees that all aforementioned information is
              true and in no means is false and intended to influence the credit
              underwriting of the Lender in regard to origination of the loan
              associated with the subject property or properties. Additionally,
              the borrower understands that this loan application does not
              constitute a commitment from the Lender to originate the loan
              associated with the subject property or properties. Lastly, the
              borrower acknowledges that all fees collected in relation to loan
              due diligence are non-refundable, in any circumstance.
            </Txt>
            <Txt>
              If necessary, I hereby authorize and instruct the Lender and its
              vendors/affiliates to obtain and review my personal credit report,
              background checks, and all other reports and documents and
              involving due diligence in connection with my real estate loan. I
              understand and agree that the Lender and its vendors/affiliates
              intends to use the credit report for the purpose of evaluating my
              financial readiness to personally guarantee the real estate loan
              that I have applied for. My signature below authorizes the release
              to credit report and screening agencies of financial or other
              information that I have supplied to the Lender and its
              vendors/affiliates in connection with such evaluation.
              Authorization is further granted to the credit report and
              screening agencies to use a copy of this form to obtain any
              information the agencies may deem necessary to complete my credit
              report and/or background screenings.
            </Txt>
          </TextOverflow>
        </Grid>
        <RffSignatureField name="signature" label="Signature" />
      </RffGroup>
    </>
  );
};
/**
 * Shared
 */

const TextOverflow = ({ children, maxHeight = "280px" }) => {
  return (
    <Flx
      column
      gap={2}
      sx={{
        maxHeight: maxHeight,
        overflowY: "auto",
        p: 2,
        border: `1px solid ${grey[300]}`,
        borderRadius: "4px",
      }}
    >
      {children}
    </Flx>
  );
};

export default LoanApplicationFormScreen;
